module.exports = __webpack_public_path__ + "images/view-dashboard.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/view-dashboard.svg
 ** module id = 57
 ** module chunks = 1
 **/